/* eslint-disable no-secrets/no-secrets */
import React, { useContext, useCallback, useState } from 'react';
import _ from 'lodash';
import { BreakpointTrackerContext } from '@jutro/layout';
import { wizardProps } from '@xengage/gw-portals-wizard-react';
import { ViewModelForm } from '@xengage/gw-portals-viewmodel-react';
import { useValidation } from '@xengage/gw-portals-validation-react';
import { readViewModelValue } from '@xengage/gw-jutro-adapters-react';
import { withRouter } from 'react-router-dom';

import { useModal } from '@jutro/components';
import AddressComponent from "premier-capability-policyjob-react/components/AddressComponent/AddressComponent";
import { useTranslator } from '@jutro/locale';
import metadata from './InformationComponent.metadata.json5';
import styles from '../../ITProfessional/ITProfessional.module.scss';
import messages from './InformationComponent.messages';
import CoveragesPageComponent from "../../../pages/Coverages/CoveragesPage";

function InformationComponent(props) {

    const { submissionVM, updateWizardData, pathUpdated, offeringCode, viewModelService } = props;
    const breakpoint = useContext(BreakpointTrackerContext);
    const { onValidate } = useValidation('InformationComponent');
    const modelVM = _.get(submissionVM, pathUpdated)
    const dirMedMis = ['DirAndOff', 'MedPro', 'MisPro']
    const medMis = ['MedPro', 'MisPro']
    const { showConfirm } = useModal();
    const [isEditAddress, setIsEditAddress] = useState(false)
    const [actAddress, setActAddress] = useState(null)
    const translator = useTranslator()
    
    modelVM.isValidationReq.value = true
    modelVM.desProDevReq.value = _.get(submissionVM.value, 'lobData.proLine.coverables.accountantCoverable.productCoverageSelection.cri7')

    if (_.isUndefined(modelVM.accountAddressOfLocRisk.value)) {
        const model = { country: 'CA' }
        const { _xCenter, _dtoName } = modelVM.accountAddressOfLocRisk;
        const addressDetailsVM = viewModelService.create(model, _xCenter, _dtoName);

        _.set(modelVM, 'accountAddressOfLocRisk.value', addressDetailsVM.value)
    }

    const handleValueChange = useCallback(
        (value, changedPath) => {
            let fullPath = `${pathUpdated}.${changedPath}`;

            if (value === 'new' && changedPath === 'actAdrsPublicID') {
                setIsEditAddress(true)
            }

            if (changedPath === 'yearBuilt') {
                _.set(modelVM, 'rooDatLasUpd.value', value);
                _.set(modelVM, 'heaYeaLasUpa.value', value);
                _.set(modelVM, 'eleYeaLasUpd.value', value);
            }

            if (changedPath === 'neighbouringAcc' || changedPath === 'neighbouring') {
                fullPath = `${pathUpdated}.${changedPath}.value`;

                if (_.isUndefined(_.get(submissionVM, `${fullPath}`))) {
                    _.set(submissionVM, `${fullPath}`, []);
                }

                _.set(submissionVM, `${fullPath}`, value);
            } else {
                _.set(submissionVM, `${fullPath}`, value);
            }

            if (changedPath === 'firProDisToFirHyd' || changedPath === 'firProDisToFirDep') {
                const firProDisToFirHyd = _.get(modelVM, 'firProDisToFirHyd.value.code')
                const firProDisToFirDep = _.get(modelVM, 'firProDisToFirDep.value.code')
                let proGra = ''

                if (firProDisToFirDep === 'WithFivKM') {
                    if (firProDisToFirHyd === 'Within150m' || firProDisToFirHyd === 'Within300m') {
                        proGra = 'Protected'
                    } else if (firProDisToFirHyd === 'Over300m') {
                        proGra = 'SemPro'
                    }
                } else if (firProDisToFirDep === 'BetFivKMToEigKM') {
                    if (firProDisToFirHyd === 'Within150m' || firProDisToFirHyd === 'Within300m') {
                        proGra = 'Protected'
                    } else if (firProDisToFirHyd === 'Over300m') {
                        proGra = 'SemPro'
                    }
                } else if (firProDisToFirDep === 'OveEigKM') {
                    if (firProDisToFirHyd === 'Within150m' || firProDisToFirHyd === 'Within300m' || firProDisToFirHyd === 'Over300m') {
                        proGra = 'Unprotected'
                    }
                } else if (firProDisToFirDep === 'WitEigKM') {
                    if (firProDisToFirHyd === 'Within300m' || firProDisToFirHyd === 'Within150m') {
                        proGra = 'Protected'
                    } else if (firProDisToFirHyd === 'Over300m') {
                        proGra = 'SemPro'
                    }
                } else if (firProDisToFirDep === 'OveEigKmTweKm') {
                    if (firProDisToFirHyd === 'Within150m' || firProDisToFirHyd === 'Within300m' || firProDisToFirHyd === 'Over300m') {
                        proGra = 'Unprotected'
                    }
                } else if (firProDisToFirDep === 'OveTweKm') {
                    if (firProDisToFirHyd === 'Within150m' || firProDisToFirHyd === 'Within300m' || firProDisToFirHyd === 'Over300m') {
                        proGra = 'Unprotected'
                    }
                }

                 _.set(modelVM, 'proGra.value', proGra);
            }

            updateWizardData(submissionVM);
        },
        [modelVM, pathUpdated, submissionVM, updateWizardData]
    );

    const onAddressChange = useCallback((value, changedPath) => {
        const fullPath = `${pathUpdated}.accountAddressOfLocRisk.${changedPath}`;

        _.set(submissionVM, `${fullPath}`, value);
        updateWizardData(submissionVM);
    }, [pathUpdated, submissionVM, updateWizardData]);

    const deriveLabelForFireDepartment = () => {
        if (offeringCode === 'DirAndOff') {
            return messages.firProDisToFirDepDnO
        }

        if (offeringCode === 'MedPro') {
            return messages.firProDisToFirHall
        }

        return messages.firProDisToFirDep
    }

    const getCheckBoxValue = useCallback((values) => {
        const result = [];

        _.forEach(values, (value) => {
            if (value) {
                result.push(value);
            }
        });

        return result;
    }, []);

    const getAddressOptions = () => {
        const availableValues = submissionVM.value.baseData.account_Ext.accountLocations_Ext.map((actLct) => ({
            code: actLct.publicID,
            name: actLct.displayName
        }));

        return availableValues.concat({
            code: 'new',
            name: '-- Add New --'
        })
    };

    const setIsEditButton = () => {
        setActAddress(modelVM.accountAddressOfLocRisk.value)
        setIsEditAddress(true)
    }

    const setIsCancelButton = () => {
        const model = actAddress
        const { _xCenter, _dtoName } = modelVM.accountAddressOfLocRisk;
        const addressDetailsVM = viewModelService.create(model, _xCenter, _dtoName);

        _.set(modelVM, 'accountAddressOfLocRisk.value', addressDetailsVM.value)
        setIsEditAddress(false)
    }

    const setIsSaveButton = () => {
        setIsEditAddress(false)
    }

    const fillAddressDetails = (value, changedPath) => {
        handleValueChange(value, changedPath)

        if (value === 'new') {
            const model = { country: 'CA', publicID: value }
            const { _xCenter, _dtoName } = modelVM.accountAddressOfLocRisk;
            const addressDetailsVM = viewModelService.create(model, _xCenter, _dtoName);

            _.set(modelVM, 'accountAddressOfLocRisk.value', addressDetailsVM.value)
        } else {

            modelVM.accountAddressOfLocRisk.value = _.find(submissionVM.value.baseData.account_Ext.accountLocations_Ext, (actLct) => actLct.publicID === value);
        }

        handleValueChange(modelVM.accountAddressOfLocRisk.value, 'accountAddressOfLocRisk')
    };


    const getAvailValuesforDisToFirDep = useCallback(() => {
        const itDirMis = ['ITPro', 'DirAndOff', 'MisPro']
        const availableValuesofDisToFirDep = _.get(modelVM, 'firProDisToFirDep.aspects.availableValues[0].typelist.filters')
        let result = []

        if (itDirMis.includes(_.get(submissionVM.value, 'lobData.proLine.selectedOffering_Ext'))) {
            result = availableValuesofDisToFirDep.filter((typecode) => typecode.name === 'ITOffering')
        } else if (_.get(submissionVM.value, 'lobData.proLine.selectedOffering_Ext') === 'Med') {
            result = availableValuesofDisToFirDep.filter((typecode) => typecode.name === 'MedOffering')
        } else {
            result = availableValuesofDisToFirDep.filter((typecode) => typecode.name === 'OthOffering')
        }

        if (_.isEmpty(result)) {
            return []
        }

        const res = result[0]?.codes?.map((typeCode) => ({
            code: typeCode.code,
            name: translator({
                id: typeCode.name,
                defaultMessage: typeCode.name
            })
        }))

        return res;
    }, [modelVM, submissionVM.value, translator])

    // eslint-disable-next-line react-hooks/exhaustive-deps
    const overrideProps = {
        '@field': {
            showRequired: true,
            labelPosition: breakpoint === 'desktop' ? 'left' : 'top'
        },
        inspDate: {
            visible: ['DirAndOff', 'MedPro', 'Acc'].includes(offeringCode)
        },
        inspDatePropertyDetails: {
            visible: ['MisPro'].includes(offeringCode)
        },
        rooYea: {
            visible: offeringCode === 'ArcEng'
        },
        pluYea: {
            visible: offeringCode === 'ArcEng'
        },
        eleYeaLasUpd: {
            visible: !dirMedMis.includes(offeringCode)
        },
        eleDatLasUpd: {
            visible: medMis.includes(offeringCode),
            defaultValue: new Date().getFullYear()
        },
        eleDatLasUpt: {
            visible: offeringCode === 'DirAndOff'
        },
        eleSysOth: {
            visible: !_.isUndefined(modelVM.value.eleSys) && modelVM.value.eleSys === 'Other'
        },
        heaYeaLasUpa: {
            visible: !dirMedMis.includes(offeringCode)
        },
        heaDatLasUpd: {
            visible: medMis.includes(offeringCode),
            defaultValue: new Date().getFullYear()
        },
        heaDatLasUpt: {
            visible: offeringCode === 'DirAndOff'
        },
        heatingOth: {
            visible: !_.isUndefined(modelVM.value.heating) && modelVM.value.heating === 'Other',
            label: offeringCode === 'DirAndOff' ? messages.heatingOthDnO : messages.ifOthExp16
        },
        firProDisToFirDep: {
            label: deriveLabelForFireDepartment(),
            availableValues: getAvailValuesforDisToFirDep()
        },
        firProDisToFirHyd: {
            label: offeringCode === 'DirAndOff' ? messages.firProDisToFirHydDnO : messages.firProDisToFirHyd
        },
        rooDatLasUpd: {
            visible: ['ITPro', 'MisPro', 'Med', 'MedPro'].includes(offeringCode),
            defaultValue: new Date().getFullYear()
        },
        numOfStories: {
            label: offeringCode === 'MedPro' ? messages.noOfStories : messages.numOfStories
        },
        conTypBuiOth: {
            visible: !_.isUndefined(modelVM.value.conTypBui) && modelVM.value.conTypBui === 'Other',
            label: offeringCode === 'DirAndOff' ? messages.conTypBuiOthDnO : messages.ifOthExp16
        },
        neighbouring: {
            visible: false,
            value: getCheckBoxValue(modelVM.value.neighbouring),
            onValueChange: handleValueChange
        },
        neighbouringOth: {
            visible: !_.isUndefined(modelVM.value.neighbouring) && _.includes(modelVM.value.neighbouring, 'Oth'),
            required: !_.isUndefined(modelVM.value.isValidationReq) && modelVM.value.isValidationReq && !_.isUndefined(modelVM.value.neighbouring) && _.includes(modelVM.value.neighbouring, 'Oth'),
        },
        neighbouringAcc: {
            value: getCheckBoxValue(modelVM.value.neighbouringAcc),
            onValueChange: handleValueChange
        },
        neighbouringAccOth: {
            visible: !_.isUndefined(modelVM.value.neighbouringAcc) && _.includes(modelVM.value.neighbouringAcc, 'Other'),
            label: ['DirAndOff', 'MedPro'].includes(offeringCode) ? messages.typOfNeiOccOthDnO : messages.ifOthExp16,
            required: !_.isUndefined(modelVM.value.isValidationReq) && modelVM.value.isValidationReq && !_.isUndefined(modelVM.value.neighbouringAcc) && _.includes(modelVM.value.neighbouringAcc, 'Other'),
        },
        actAdrsPublicID: {
            availableValues: getAddressOptions(),
            onValueChange: fillAddressDetails
        },
        description: {
            visible: offeringCode !== 'MisPro'
        },
        crimeTitle: {
            visible: !_.isUndefined(submissionVM.value.lobData.proLine.coverables.isCriCovTabVisible) && submissionVM.value.lobData.proLine.coverables.isCriCovTabVisible
        },
        desProDev: {
            visible: !_.isUndefined(submissionVM.value.lobData.proLine.coverables.isCriCovTabVisible) && submissionVM.value.lobData.proLine.coverables.isCriCovTabVisible
        },
        locRiskddressComponent: {
            labelPosition: 'left',
            value: modelVM.accountAddressOfLocRisk,
            viewModelService,
            readOnly: isEditAddress ? [] : ['addressLine1Field', 'addressLine2Field', 'addressLine3Field', 'addressCity', 'addressState', 'addressPostalCode'],
            hideFields: ['addressDescription', 'addressType', 'addressCountry', 'addressCounty'],
            requiredFields: ['addressLine1Field', 'postalCode'],
            onValueChange: onAddressChange
        },
        editAddressButton: {
            visible: modelVM.actAdrsPublicID.value !== 'new' && !isEditAddress
        },
        saveAddressButton: {
            visible: modelVM.actAdrsPublicID.value === 'new' || isEditAddress
        },
        cancelAddressButton: {
            visible: modelVM.actAdrsPublicID.value !== 'new' && isEditAddress
        }
    };


    const deleteinformation = useCallback(
        () => {
            const infoListPath = 'lobData.proLine.coverables.locRisks.value';
            const info = modelVM.value;
            const infoList = _.get(submissionVM, infoListPath);

            showConfirm({
                title: messages.removeInfo,
                message: messages.removeInfoDesc,
                status: 'warning',
                icon: 'mi-error-outline',
                confirmButtonText: messages.yes,
                cancelButtonText: messages.no
            }).then(
                (results) => {
                    if (results === 'cancel') {
                        return _.noop();
                    }

                    const newinfoList = _.remove(infoList,
                        (infoFromList) => _.isEqual(infoFromList, info));

                    _.set(submissionVM, newinfoList, infoListPath);
                    updateWizardData(submissionVM);

                    return true;
                }, _.noop
            );
        }, [modelVM.value, submissionVM, showConfirm, updateWizardData]
    );


    const resolvers = {
        resolveCallbackMap: {
            deleteinformation,
            onValidate,
            setIsEditButton,
            setIsCancelButton,
            setIsSaveButton
        },
        resolveComponentMap: {
            coveragespagecomponent: CoveragesPageComponent,
            AddressComponent
        },
        resolveClassNameMap: styles
    };

    const readValue = useCallback(
        (id, path) => readViewModelValue(metadata.componentContent, _.get(submissionVM, pathUpdated), id, path, overrideProps),
        [overrideProps, pathUpdated, submissionVM]
    );

    return (
        <ViewModelForm
            uiProps={metadata.componentContent}
            model={modelVM}
            // onModelChange={updateWizardData}
            resolveValue={readValue}
            overrideProps={overrideProps}
            onValidationChange={onValidate}
            onValueChange={handleValueChange}
            callbackMap={resolvers.resolveCallbackMap}
            componentMap={resolvers.resolveComponentMap}
            classNameMap={resolvers.resolveClassNameMap}
        />
    );


}

InformationComponent.propTypes = wizardProps;
export default withRouter(InformationComponent);
